import { Controller } from "@hotwired/stimulus"
import { clockText } from "../lib/clock_format"

// A live clock for the "clock" deck element, in the Beacon's time zone (the
// server passes it; blank falls back to the screen's own). The server renders
// the same text for the first paint and for an export, which has no clock to
// tick, so this only keeps it moving.
export default class extends Controller {
  static values = { timeZone: String, showDate: { type: Boolean, default: true }, showSeconds: { type: Boolean, default: true } }

  connect() {
    this.tick()
    this.timer = setInterval(() => this.tick(), this.showSecondsValue ? 1000 : 15000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  tick() {
    this.element.textContent = clockText(new Date(), {
      timeZone: this.timeZoneValue,
      showDate: this.showDateValue,
      showSeconds: this.showSecondsValue
    })
  }
}
